import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

// Sprachschalter temporär aktiviert für Testing
const isLanguageSwitcherEnabled = true; // process.env.REACT_APP_ENV !== 'production';

// TypeScript-Interface für die i18n-Konfiguration
interface I18nConfig {
  supportedLngs: string[];
  fallbackLng: string;
  lng?: string;
  detection?: {
    order: string[];
    caches: string[];
  };
  backend: {
    loadPath: string;
  };
  react: {
    useSuspense: boolean;
  };
}

// Cache-bust the runtime-loaded translation files. They live at a fixed,
// unhashed URL the CDN keeps for a day, so without a version query freshly
// added keys show up as raw keys after a deploy. Builds set the version to a
// hash of the files (craco.config.js, scripts/translation-version.js); the
// fallback only covers the dev server, which serves them fresh anyway.
const TRANSLATION_VERSION =
  process.env.REACT_APP_TRANSLATION_VERSION || "2026-09-29.2";

// Basis-Konfiguration
const config: I18nConfig = {
  supportedLngs: ["en", "de"],
  fallbackLng: "de",
  backend: {
    loadPath: `/locales/{{lng}}/translation.json?v=${TRANSLATION_VERSION}`,
  },
  react: { useSuspense: true },
};

// Initialisierung mit HttpApi
i18n.use(HttpApi);

// Language Detector nur verwenden, wenn der Sprachschalter aktiviert ist
if (isLanguageSwitcherEnabled) {
  i18n.use(LanguageDetector);
  // Detection-Konfiguration hinzufügen
  config.detection = {
    order: ["path", "cookie", "htmlTag", "localStorage", "subdomain"],
    caches: ["cookie"],
  };
} else {
  // Feste Sprache auf Deutsch setzen, wenn Sprachschalter deaktiviert ist
  config.lng = "de";
}

// React-i18next Initialisierung
i18n.use(initReactI18next).init(config);

export default i18n; 